var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 347"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 11",
    x1: 1.41421,
    y1: 1,
    x2: 20.1525,
    y2: 19.7383,
    stroke: "#262E80",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 12",
    x1: 1,
    y1: -1,
    x2: 27.5,
    y2: -1,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 21.1526 1)",
    stroke: "#262E80",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fcb224b0aebec2b9e91ec1ab87e03801.svg";
export { ForwardRef as ReactComponent };